import { __callbacks } from "Utils/Callbacks/Callback";
import { ChatMessageFragment } from "Utils/Chats/ChatMessageFragment";
import { Chat } from "Utils/Enums";
import { __map } from "Utils/Map/Map";
import { __utils } from "Utils/Utils";
import { useCallback, useEffect, useState } from "react";
import ButtonSubmit from "./components/ButtonSubmit/ButtonSubmit";
import InputEmail from "./components/Input/components/InputEmail/InputEmail";
import InputText from "./components/Input/components/InputText/InputText";
import styles from "./Form.module.scss";
import { __sb } from "Utils/SB/sb";

const callbackIds = {
    onInputText: "",
    onInputEmail: "",
    onInputTerms: ""
};

export default function Form(props: any) {
    const [isNameValid, setIsNameValid] = useState(false);
    const [nameValue, setNameValue] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [emailValue, setEmailValue] = useState("");
    const [isCheckBox, setIsCheckBox] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [submit, setSubmit] = useState(props.submit ?? false);

    const handleFormUpdate = useCallback(() => {

        const fragmentNo = props.fragmentNo ?? __map.getFragmentNoFromId(props.id);

        const chatMessageFragmentProps = {
            id: props.id,
            conversationId: props.conversationId,
            messageNo: props.messageNo,
            messageType: props.messageType,
            name: nameValue,
            email: emailValue,
            checked: isCheckBox,
            submit: submit,
            // Ensure that the text property is set
            text: `Name: ${nameValue}, Email: ${emailValue}, Checked: ${isCheckBox}, Submit: ${submit}`
        };

        __callbacks.formUpdate.trigger({
            type: Chat.Fragment,
            data: new ChatMessageFragment({
                id: __utils.getUuidv4(),
                chatId: props.conversationId,
                messageNo: props.messageNo,
                messageType: props.messageType,
                fragmentType: "Form",
                time: Date.now(),
                props: chatMessageFragmentProps
            })
        });

        // Check if it's a bot conversation and skip processing if true
        if (localStorage.getItem('bot_conversation' + props.conversationId) === 'true') {
            return;
        }

    }, [props, nameValue, emailValue, isCheckBox, submit]);


    useEffect(() => {
        setIsFormValid(isNameValid && isEmailValid && isCheckBox);
    }, [isNameValid, isEmailValid, isCheckBox]);

    const onSubmit = () => {

        setSubmit(true);

        handleFormUpdate();

        var cid = __sb.getContactId(nameValue, emailValue, true, props.conversationId);

        __callbacks.formSubmit.trigger({
            name: nameValue,
            email: emailValue
        });

        __callbacks.removeListener.trigger({});

    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' && isFormValid) {
            event.preventDefault();
            onSubmit();
        }
    };

    useEffect(() => {
        if (!submit) return;

        __callbacks.inputText.remove(callbackIds.onInputText);
        __callbacks.inputEmail.remove(callbackIds.onInputEmail);
        __callbacks.inputTerms.remove(callbackIds.onInputTerms);
    }, [submit]);

    useEffect(() => {
        callbackIds.onInputText = __callbacks.onInputText(({ isValid, value }: { isValid: boolean, value: string }) => {
            setIsNameValid(isValid);
            setNameValue(value);
            setIsCheckBox(true);
        });
        callbackIds.onInputEmail = __callbacks.onInputEmail(({ isValid, value }: { isValid: boolean, value: string }) => {
            setIsEmailValid(isValid);
            setEmailValue(value);
            setIsCheckBox(true);
        });
    }, []);

    return (
        <div className={`${styles.container} config-msg-receive-fragment`} onKeyDown={handleKeyDown}>
            <div className={styles["container-form"]}>
                <form action="">
                    We just need a little more information to connect you.<br /><br />
                    <InputText title="Name" type="text" value={props.name}></InputText>
                    <InputEmail title="Email" type="email" value={props.email}></InputEmail>
                    <br />
                    <ButtonSubmit submit={submit} disable={!isFormValid} onClick={onSubmit}></ButtonSubmit>
                </form>
            </div>
        </div>
    );
}
